export enum IOrderByType {
    Ascendent = 0,
    Descendent = 1
}